// src/components/ui/Logo.jsx
// STATUS: active | UPDATED: 2026-08-27
// LOG:
//   2026-08-27  New. Extracted from three separate <Image src="/j13-logo.png">
//               call sites (Login, ResetPassword, Sidebar) after dark mode made
//               the mark almost invisible on the login screen.
// NEXT: if a true light-on-dark lockup is ever produced, swap the filter for a
//       second asset here and nothing else in the app has to change.
//
// The J|13 mark. j13-logo.png is a single-weight lockup: transparent
// background, neutral ink at roughly #1A1A1A, no brand colour anywhere in it
// (verified by sampling the file). That is why a plain invert is safe here and
// would not be on a coloured logo, where it would rotate the hue.
//
// On dark, invert(1) takes the ink to about #E5E5E5 and leaves the transparent
// ground alone, which is exactly the lockup we would have drawn by hand.

import { Image, useColorModeValue } from '@chakra-ui/react'

export default function Logo({ alt = 'J|13 Dealer Academy', ...props }) {
  const filter = useColorModeValue('none', 'invert(1)')

  return <Image src="/j13-logo.png" alt={alt} filter={filter} {...props} />
}
